import React, { useCallback, useState, useMemo } from 'react'
import { Outlet } from 'react-router-dom'

import AsideMenu from '../AsideMenu'
import LayoutHeader from '../LayoutHeader'
import HeaderNavigation from '../HeaderNavigation'
import Content from '../Content'

import { onDisabledScrollHandler, onEnableScrollHandler } from '../../utils/ScrollHandler'

import { Container } from './styles'

interface ILayoutProps {
    deleteNav?: boolean;
}

const Layout: React.FC<ILayoutProps> = ({ deleteNav }) => {

    const [asideMenuIsOpen, setAsideMenuIsOpen] = useState<boolean>(false)

    const navigationItemsMemo = useMemo(() => (
        [
            { to: '/products', label: 'Produtos' },
            { to: '/my-wishlists', label: 'Minhas lojinhas' }
        ]
    ), [])

    const onCloseAsideMenuHandler = useCallback(() => {
        onEnableScrollHandler()
        return setAsideMenuIsOpen(false)
    }, [])

    const onOpenAsideMenuHandler = useCallback(() => {
        onDisabledScrollHandler()
        return setAsideMenuIsOpen(true)
    }, [])

    return (
        <Container deleteNav={deleteNav}>
            <AsideMenu isOpen={asideMenuIsOpen} onClose={onCloseAsideMenuHandler} />
            <LayoutHeader className="search__open" onOpenAside={onOpenAsideMenuHandler} deleteNav={deleteNav} navigationItems={navigationItemsMemo} />
            <HeaderNavigation
                className={"nav__mobile--container"}
                navigationItems={navigationItemsMemo}
                deleteNav={deleteNav} />
            <Content>
                <Outlet />
            </Content>
        </Container>
    )
}

export default Layout